(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["2025-timeline"] && !Shopify.designMode) return;
  try {
    
  const timelineToggles = document.querySelectorAll('[data-timeline-toggle]'); 
  const timelineCardToggles = document.querySelectorAll('[data-timeline-card-toggle]');

  if (timelineToggles.length) {
    timelineToggles.forEach((toggle) => {
      toggle.addEventListener('click', (e) => {
        const container = e.target.closest('.splide__list');
        const hiddenItems = container.querySelectorAll('.splide__slide:nth-child(n+5)');

        if (container.classList.contains('is-expanded')) {
          container.classList.remove('is-expanded');
          toggle.textContent = 'See More Content +';

          hiddenItems.forEach((item) => {
            item.classList.add('max-sm:tw-hidden');
          });
        } else {
          container.classList.add('is-expanded');
          toggle.textContent = 'Collapse -';

          hiddenItems.forEach((item) => {
            item.classList.remove('max-sm:tw-hidden');
          });
        }
      });
    });
  }

  if (timelineCardToggles.length) {
    timelineCardToggles.forEach((toggle) => {
      toggle.addEventListener('click', (e) => {
        const hiddenContent = toggle.previousElementSibling;
        const isHidden = hiddenContent.classList.contains('tw-hidden');

        if (isHidden) {
          hiddenContent.classList.remove('tw-hidden');
          toggle.textContent = 'Collapse -';
          toggle.setAttribute('data-track-event', 'Timeline - Learn More');
        } else {
          hiddenContent.classList.add('tw-hidden');
          toggle.textContent = 'Learn More +';
          toggle.setAttribute('data-track-event', 'Timeline - Collapse');
        }
      });
    });
  }

  } catch(e) { console.error(e); }
})();
})();
